import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { patientAnalysesActions } from 'features/patientAnalyses';

const usePatientAnalyses = () => {
  const dispatch = useDispatch();
  const getPatientAnalyses = useCallback(({ offset }) => dispatch(patientAnalysesActions.getPatientAnalyses({ offset })), [dispatch]);
  const getPatientAnalysis = useCallback(({ id, cable }) => dispatch(patientAnalysesActions.getPatientAnalysis({ id, cable })), [dispatch]);
  const clearLocalPatientAnalyses = useCallback(() => dispatch(patientAnalysesActions.clearLocalPatientAnalyses()), [dispatch]);
  const clearLocalActivePatientAnalysis = useCallback(() => dispatch(patientAnalysesActions.clearLocalActivePatientAnalysis()), [dispatch]);

  return {
    getPatientAnalyses,
    getPatientAnalysis,
    clearLocalPatientAnalyses,
    clearLocalActivePatientAnalysis
  };
};

export default usePatientAnalyses;